import type { AppDef } from "../../shell/nav";
import { AgentsPage } from "./AgentsPage";
import { AndroidPage } from "./AndroidPage";
import { DeviceDetailPage } from "./DeviceDetailPage";
import { DevicesPage } from "./DevicesPage";
import { EquipmentLinkPage } from "./EquipmentLinkPage";
import { RegistryPage } from "./RegistryPage";

export const MDM: AppDef = {
  key: "mdm",
  name: "デバイス管理",
  defaultPath: "devices",
  groups: [
    {
      label: "台帳",
      items: [
        { path: "devices", label: "デバイス台帳", phase: "R4", component: DevicesPage, feature: ["mdm.apple", "mdm.windows", "mdm.android"] },
        { path: "equipment", label: "備品マスタ", phase: "R4", component: EquipmentLinkPage, feature: ["mdm.apple", "mdm.windows"] },
      ],
    },
    {
      label: "配布・連携",
      items: [
        { path: "registry", label: "レジストリ配布", phase: "R4", component: RegistryPage, feature: "mdm.windows" },
        { path: "agents", label: "エージェント連携", phase: "R4", component: AgentsPage, feature: "mdm.windows" },
        { path: "android", label: "Android", phase: "MOB2", component: AndroidPage, feature: "mdm.android" },
      ],
    },
  ],
  extraRoutes: [
    // 1 台の詳細(UX1-b2 で Drawer から独立。URL で共有できる)
    { path: "devices/:deviceId", component: DeviceDetailPage },
  ],
};
